let _month;
let _year;
let _salespersonId;
let _company;

export default function (company, month, year, salespersonId) {
    _month = month;
    _year = year;
    _salespersonId = salespersonId;
    _company = company;
    let data = {
        month: _month,
        year: _year,
        company: _company,
        salespersonId: _salespersonId
    }
    loadMilestones(data);
}

function loadMilestones(data) {
    $('.js-ssr-commissions-milestones').load('/Finance/SellerBuilderCommissions/Milestones', data, function () {
    });
}
